import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css, keyframes } from '@emotion/core';
import { stylingHelpers } from '../../designTokens';

const { flexCenter } = stylingHelpers;

const baseStyles = ({ variant }) =>
  variant !== 'secondary' &&
  css`
    width: 100%;

    ${flexCenter()};
  `;

const variantStyles = ({ variant }) => variant === 'secondary' && css``;

const Container = styled('div')(baseStyles, variantStyles);

const blink = ({ theme }) => {
  return keyframes`
    50% {
      background-color: ${theme.colors.red};
    }
  `;
};

const iconBaseStyles = ({ theme, isLite }) => css`
  display: block;
  background-color: ${theme.colors.n500};
  border-radius: ${theme.borderRadius.circle};
  width: 12px;
  height: 12px;
  margin: 0 ${theme.spacings.bit};
  animation: ${blink({ theme, isLite })} 1s infinite;

  &:nth-of-type(1) {
    animation-delay: 0ms;
  }

  &:nth-of-type(2) {
    animation-delay: 250ms;
  }

  &:nth-of-type(3) {
    animation-delay: 500ms;
  }
`;

const iconLargeStyles = ({ variant }) =>
  variant === 'secondary' &&
  css`
    width: 20px;
    height: 20px;
    margin: 0;
  `;

const Icon = styled('span')(iconBaseStyles, iconLargeStyles);

const LoadingIcon = ({ size, variant }) => (
  <Container variant={variant}>
    {new Array(size).fill(null).map((item, index) => (
      <Icon key={`loading-icon-${index}`} variant={variant} />
    ))}
  </Container>
);

LoadingIcon.propTypes = {
  size: PropTypes.number,
  variant: PropTypes.string,
};

LoadingIcon.defaultProps = {
  size: 3,
};

export default LoadingIcon;
